import { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";
import { BRAND } from "@/lib/content";

const links = [
  { href: "#services", label: "Services" },
  { href: "#realisations", label: "Réalisations" },
  { href: "#apropos", label: "À propos" },
  { href: "#contact", label: "Contact" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="navbar"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-white/85 backdrop-blur-xl border-b border-black/5"
          : "bg-transparent"
      }`}
    >
      <nav className="max-w-7xl mx-auto px-6 md:px-10 h-20 flex items-center justify-between">
        <a
          href="#top"
          data-testid="brand-logo"
          className="flex items-center gap-2 group"
        >
          <img
            src="/logo.png"
            alt="FB Services logo"
            className={`h-11 md:h-12 w-auto object-contain transition-all duration-300 ${scrolled ? "" : "drop-shadow-[0_2px_8px_rgba(0,0,0,0.5)]"}`}
          />
        </a>

        <div className="hidden md:flex items-center gap-9">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className={`text-sm font-medium transition-colors ${scrolled ? "text-[#1E2320]/80 hover:text-[#1A4331]" : "text-white/90 hover:text-white"}`}
            >
              {l.label}
            </a>
          ))}
        </div>

        <div className="hidden md:flex items-center">
          <a
            href="#contact"
            data-testid="nav-cta-devis"
            className={`inline-flex items-center justify-center rounded-full px-6 py-2.5 text-sm font-medium transition-all duration-300 ${scrolled ? "bg-[#1A4331] text-white hover:bg-[#123022]" : "bg-white text-[#1A4331] hover:bg-white/90"}`}
          >
            Demander un devis
          </a>
        </div>

        <button
          data-testid="mobile-menu-toggle"
          className={`md:hidden grid place-items-center h-10 w-10 rounded-full transition-colors ${scrolled ? "border border-black/10 bg-white/70 text-[#1E2320]" : "border border-white/30 bg-white/15 text-white"}`}
          onClick={() => setOpen((s) => !s)}
          aria-label="Menu"
        >
          {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
        </button>
      </nav>

      {open && (
        <div className="md:hidden bg-white border-t border-black/5">
          <div className="px-6 py-4 flex flex-col gap-3">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                data-testid={`nav-mobile-link-${l.label.toLowerCase()}`}
                className="py-2 text-base font-medium text-[#1E2320]"
              >
                {l.label}
              </a>
            ))}
            <a
              href="#contact"
              onClick={() => setOpen(false)}
              data-testid="nav-mobile-cta-devis"
              className="mt-2 inline-flex items-center justify-center rounded-full px-6 py-3 text-sm font-medium bg-[#1A4331] text-white"
            >
              Demander un devis
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
